import { FetchLike, Middleware } from 'wretch/dist/middleware';
import { WretcherResponse } from 'wretch/dist/resolver';
import { WretcherOptions } from 'wretch/dist/wretcher';
import { buildErrorFromJsonApiResponse } from '../api';

export const errorMiddleware: Middleware = () => (next: FetchLike) => async (
  url: string,
  opts: WretcherOptions
): Promise<WretcherResponse> => {
  const response = await next(url, opts);

  if (!response.ok) {
    let payload;

    try {
      payload = await response.json();
    } catch (e) {
      payload = null;
    }

    const error = buildErrorFromJsonApiResponse(response, payload);

    return Promise.reject(error);
  }

  return response;
};
